import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withIcon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-teal-500 text-white hover:bg-teal-600 shadow-lg hover:shadow-xl focus:ring-teal-500 border border-transparent',
    secondary: 'bg-navy-900 text-white hover:bg-navy-800 shadow-md hover:shadow-lg focus:ring-navy-900 border border-transparent',
    outline: 'bg-transparent border-2 border-navy-900 text-navy-900 hover:bg-navy-50 focus:ring-navy-900'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} onClick={e => {
    window.open('https://www.versastorex.com/cart/41995041996880:1', '_blank');
    props.onClick?.(e);
  }} {...props} data-id="element-129">
      Start my plan
    </button>;
}